import { Collapse } from 'antd'

import _map from 'lodash/map'

import Title from 'components/Title'

import Styled from './styled'

export default function MyCollapse({ items = [], defaultActiveKey = ['0'], ...props }) {
  return (
    <Styled>
      <Collapse defaultActiveKey={defaultActiveKey} expandIconPosition="right" ghost {...props}>
        {_map(items, (item, index) => {
          const headerLabel = item?.headerLabel
          const headerIcon = item?.headerIcon
          const uiRenderer = item?.uiRenderer
          return (
            <Collapse.Panel
              header={
                <div className="header-custom">
                  {headerIcon && <div className="header-icon">{headerIcon}</div>}
                  <Title level={4}>{headerLabel}</Title>
                </div>
              }
              key={index}
            >
              {uiRenderer}
            </Collapse.Panel>
          )
        })}
      </Collapse>
    </Styled>
  )
}
